/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxGamesLibWebPublicDataBaseTurnstileOptions
 */
export interface FxGamesLibWebPublicDataBaseTurnstileOptions {
    /**
     * Публичный ключ для Cloudflare Turnstile
     * @type {string}
     * @memberof FxGamesLibWebPublicDataBaseTurnstileOptions
     */
    SiteKey: string;
}

/**
 * Check if a given object implements the FxGamesLibWebPublicDataBaseTurnstileOptions interface.
 */
export function instanceOfFxGamesLibWebPublicDataBaseTurnstileOptions(value: object): value is FxGamesLibWebPublicDataBaseTurnstileOptions {
    if (!('SiteKey' in value) || value['SiteKey'] === undefined) return false;
    return true;
}

export function FxGamesLibWebPublicDataBaseTurnstileOptionsFromJSON(json: any): FxGamesLibWebPublicDataBaseTurnstileOptions {
    return FxGamesLibWebPublicDataBaseTurnstileOptionsFromJSONTyped(json, false);
}

export function FxGamesLibWebPublicDataBaseTurnstileOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPublicDataBaseTurnstileOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'SiteKey': json['SiteKey'],
    };
}

export function FxGamesLibWebPublicDataBaseTurnstileOptionsToJSON(json: any): FxGamesLibWebPublicDataBaseTurnstileOptions {
    return FxGamesLibWebPublicDataBaseTurnstileOptionsToJSONTyped(json, false);
}

export function FxGamesLibWebPublicDataBaseTurnstileOptionsToJSONTyped(value?: FxGamesLibWebPublicDataBaseTurnstileOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'SiteKey': value['SiteKey'],
    };
}

